import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
import { ICON_CONTAINER_WIDTH, SIDEBAR_PADDING, TRANSITION_SETTINGS } from '../config';
const SIDEBAR_MENU_WIDTH = pxToRem(260);
const SIDEBAR_MENU_WIDTH_MINIMIZED = `calc(${ICON_CONTAINER_WIDTH} + ${SIDEBAR_PADDING} * 2)`;
export const SidebarMenuContainer = styled.div `
  width: ${SIDEBAR_MENU_WIDTH};
  min-width: ${SIDEBAR_MENU_WIDTH_MINIMIZED};
  flex-shrink: 0;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${themeGet('colors.background.50')};
  border-right: solid ${pxToRem(1)} ${themeGet('colors.border.100')};

  transition: width ${TRANSITION_SETTINGS};

  ${({ $minimized }) => $minimized &&
    `
    width: ${SIDEBAR_MENU_WIDTH_MINIMIZED};
  `};
`;
